module.exports = __webpack_public_path__ + "static/media/facebook.f785a9d5.svg";